export { default as withClassname } from '@components/hoc/withClassname/WithClassname';



// WEBPACK FOOTER //
// ./src/components/hoc/withClassname/index.ts